import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

// Step 1 of the Book Meeting flow — event picker only. On Continue the dialog closes
// with the selected event; the caller then opens the separate BookingInternalDialog
// with that event preselected. Matches the Calendly pattern where step 2 is a
// separate, larger dialog.
//
// Inputs (set by caller via dialogRef.componentInstance):
//   relatedRecord  — optional CRM record the booking is for; shown in the header for context.
//   listAllEvents  — false (default) only the current user's events; true fetches all.
//                    Forwarded to the picker which now owns the fetch.
@Component({
  selector: 'book-meeting-dialog',
  templateUrl: './book-meeting-dialog.component.html',
  styleUrls: ['./book-meeting-dialog.component.scss'],
  standalone: false
})
export class BookMeetingDialogComponent {
  relatedRecord: any = null;
  listAllEvents: boolean = false;

  selectedEvent: any = null;
  // Mirrors the picker's internal `creating` flag so the dialog footer disables
  // Cancel + Continue + close-X while a fast-create save is in flight.
  creating: boolean = false;


  constructor(
    private _dialogRef: MatDialogRef<BookMeetingDialogComponent>
  ) {}


  onPickerCreatingChange(creating: boolean) {
    this.creating = creating;
  }


  getRecordDisplayName(): string {
    const r = this.relatedRecord;
    if (!r) return '';
    if (r?.name) return r.name;
    const first = (r?.first_name || r?.firstName || '').trim();
    const last = (r?.last_name || r?.lastName || '').trim();
    const composed = [first, last].filter(Boolean).join(' ');
    return composed || r?.email || '';
  }


  getRecordInitials(): string {
    const name = this.getRecordDisplayName();
    if (!name) return '';
    const parts = name.trim().split(/\s+/);
    const first = (parts[0] || '')[0] || '';
    const second = (parts[1] || '')[0] || '';
    return (first + second).toUpperCase();
  }


  onEventSelected(event: any) {
    this.selectedEvent = event;
  }


  cancel() {
    this._dialogRef.close(null);
  }


  continueToBooking() {
    if (!this.selectedEvent?._id) return;
    this._dialogRef.close(this.selectedEvent);
  }
}